import { render, staticRenderFns } from "./ednCatArbo.vue?vue&type=template&id=1cf4f40c"
import script from "./ednCatArbo.vue?vue&type=script&lang=js"
export * from "./ednCatArbo.vue?vue&type=script&lang=js"
import style0 from "./ednCatArbo.vue?vue&type=style&index=0&id=1cf4f40c&prod&lang=css"


/* normalize component */
import normalizer from "!./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports